import styled from 'styled-components';

export const Main = styled.div`
   min-width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   .textInput {
      margin-bottom: 10px;
      h4 { width: 118px; }

      &:last-of-type {
         margin-bottom: 0;
      }
   }
   .select {
      margin-bottom: 10px;
      h4 { width: 100px; }
   }
`;